document.addEventListener('DOMContentLoaded', function () {
  const mainNavBtn = document.getElementById('mainNav');
  const menuWrapper = document.getElementById('menuWrapper');
  const menuContainer = menuWrapper && menuWrapper.querySelector('.menu-container');

  // Exit early if required elements are missing
  if (!mainNavBtn || !menuWrapper || !menuContainer) return;

  // Set initial ARIA attributes
  mainNavBtn.setAttribute('aria-expanded', 'false');
  if (window.innerWidth <= 1126.9 && !menuWrapper.classList.contains('_active')) {
    menuWrapper.setAttribute('aria-hidden', 'true');
  }

  function openMenu() {
    mainNavBtn.classList.add('_active');
    menuWrapper.classList.add('_active');
    document.body.classList.add('no-scroll');

    mainNavBtn.setAttribute('aria-expanded', 'true');
    menuWrapper.setAttribute('aria-hidden', 'false');

    // Allow a slight delay before triggering the slide-in animation
    setTimeout(function () {
      menuContainer.classList.add('_slide-in');
    }, 250);
  }

  function closeMenu() {
    menuContainer.classList.remove('_slide-in');

    setTimeout(function () {
      mainNavBtn.classList.remove('_active');
      menuWrapper.classList.remove('_active');
      document.body.classList.remove('no-scroll');

      mainNavBtn.setAttribute('aria-expanded', 'false');
      menuWrapper.setAttribute('aria-hidden', 'true');
    }, 250);
  }

  mainNavBtn.addEventListener('click', function () {
    const isActive = menuWrapper.classList.contains('_active');
    if (isActive) {
      closeMenu();
    } else {
      openMenu();
    }

    // Remove focus from the button after interaction
    setTimeout(function () {
      mainNavBtn.blur();
    }, 1000);
  });

  menuWrapper.addEventListener('click', function (e) {
    if (e.target === menuWrapper) {
      closeMenu();
    }
  });

  // Close menu on window resize above 1075px
  window.addEventListener('resize', function () {
    const isActive = menuWrapper.classList.contains('_active');
    if (window.innerWidth > 1075 && isActive) {
      closeMenu();
    }
  });
});
